import React from 'react';

const ArrowLeft = 'https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/Voltar.svg';

import { CloseIcon, CloseTitle, CloseWrapper, Container, RightText } from './styles';
import HeadTitle from '../HeadTitle';

export interface NewModalProps {
  visible: boolean;
  headTitle?: string;
  children?: React.ReactNode;
  childrenFooter?: React.ReactNode;
  onClose?: () => void;
  rightText?: string;
  onPressRightText?: () => void;
  name?: string;
}

export default function NewModal({
  visible,
  headTitle,
  children,
  onClose,
  rightText,
  onPressRightText,
  name = ''
}: NewModalProps) {
  return (
    <Container visible={visible} aria-label={`modal - ${name}`} aria-hidden={!visible}>
      {onClose && (
        <CloseWrapper>
          <div>
            <HeadTitle title={headTitle || 'Voltar'} goBack={onClose} />
          </div>
          {rightText && rightText.length > 0 && (
            <RightText onClick={onPressRightText ?? (() => {})}>{rightText}</RightText>
          )}
        </CloseWrapper>
      )}

      {children}
    </Container>
  );
}
